<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--<v-container grid-list-md text-xs-center class="fluid">-->
    <v-container grid-list-sm fluid class="mt-3" style="background:#FAFAFA">
        <v-container class="border-radius mt-5" style="padding-right:25px!important;padding-left:25px!important">
            <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
            <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
            <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
            <!-- ========================================================================================= -->
            <div>
                <div>
                    <div data-v-221edead="" class="w-100 Results" pricing="true" style="--custom-color-primary:#35CE7E; --custom-color-primary-light:#5CC7000d;">
                        <div data-v-221edead="" class="d-flex flex-column flex-lg-column-reverse">
                            <div data-v-221edead="" class="container">
                                <div data-v-221edead="" class="row">
                                    <div data-v-221edead="" class="col-lg-12">
                                        <div data-v-221edead="" class="results-header mt-5" v-if="sunu_formulars!=null">
                                            <p data-v-221edead="">{{ $t('list_devis.list_devis_title[0]') }} 
                                                <strong data-v-221edead="">{{ $t('list_devis.list_devis_title[1]') }}</strong> 
                                                {{ $t('list_devis.list_devis_title[2]') }} {{sunu_formulars.length}} {{ $t('list_devis.list_devis_title[3]') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div data-v-221edead="" class=" mt-5">
                            <div class="row" v-if="isDesktop()">
                            <div class="col-lg-4" v-for="(devis,index) in sunu_formulars" :key="index">
                            <div class="pricing-box rounded text-center p-4">
                                    <div v-if="devis.reduction" class="reduction-box mb-3 text-center">
                                        <span style="margin: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;color: #ffffff;">
                                                <span style="font-weight: 350;font-size: 15px;margin-top: -10px;">{{ $t('paiement.coupon_section.label_reduction_label') }}</span>
                                                <span style="font-weight: 400;font-size: 15px;margin-bottom: -10px;">{{ devis.reduction.montant }} {{ devis.reduction.type === 'pourcentage' ? '%' : 'FCFA' }}</span>
                                        </span>
                                    </div>
                                
                                <div>
                                    <img :src="getImgUrl('https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/1739632022271-SUNU-assurances.jpg')" width="80" height="60" alt="sunu logo" style="border-radius: 10px;">
                                </div>
                                <h4 class="title mb-3">{{ devis.societe }}</h4>
                                 <h1 class="font-weight-bold mb-0 mt-3">
                                <b style="font-weight: 400;">
                                     {{devis.Formule[0].nom_formule.toUpperCase() }}
                                </b>
                                </h1>
                                <h1 class="font-weight-bold mb-0 mt-3">
                                <b>
                                    {{ devis.Formule[0].amount_total_emis.toLocaleString() }} FCFA
                                </b>
                                </h1>
                                <a href="javascript: void(0);" class="btn btn-outline-primary pr-btn mt-4" @click="btn2_clicked(devis)">{{ $t('list_devis.souscrire_label') }}</a>
                                <div class="justify-content-center row mt-3 mb-3">
                                    <a class="button-function ml-3" href="javascript: void(0);" @click="showDetailAuto()">{{ $t('list_devis.detail_label') }}</a>
                                </div>
                            </div>

                               <div data-v-221edead="" id="collapse-result-3" style="" class="collapse show" v-show="ifDevisIsAuto">
                                                <div data-v-221edead="" class="card-default-other text-left">
                                                    <div data-v-221edead="" class="table-responsive">
                                                        <pre>{{ car.lib_usage }}</pre>
                                                        <pre>{{ car.immatriculation }}</pre>
                                                       
                                                    </div>
                                                    <!-- <pre>{{ devisDetails.Formule }}</pre> -->
                                                    <div data-v-221edead="" class="table-responsive" v-for="garantie in devis.Formule" :key="garantie">
                                                        <li style="list-style: none;" v-for="gar in garantie.Garanties" :key="gar">
                                                            <span>{{ gar.Lib_Garantie }}</span>

                                                        </li>
                                                       
                                                    </div>


                                                   
                                                </div>
                                            </div>
                            </div>
                            </div>

                               <div class="row" v-if="isMobile()">
                                <div class="col-lg-12" v-for="(devis,index) in sunu_formulars" :key="index">
                                <div class="pricing-box rounded text-center p-4">
                                      <div v-if="devis.reduction" class="mb-3 reduction-box text-center">
                                            <span style="margin: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;color:#ffffff;">
                                                 <span style="font-weight: 350;font-size: 15px;margin-top: -10px;">{{ $t('paiement.coupon_section.label_reduction_label') }}</span>
                                                 <span style="font-weight: 400;font-size: 15px;margin-bottom: -10px;">{{ devis.reduction.montant }} {{ devis.reduction.type === 'pourcentage' ? '%' : 'FCFA' }}</span>
                                            </span>
                                        </div>
                                    <div>
                                        <img :src="getImgUrl('https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/1739632022271-SUNU-assurances.jpg')" width="80" height="70" alt="sunu logo" style="border-radius: 10px;">
                                    </div>
                                    <h4 class="title mb-3">{{ devis.societe }}</h4>
                                     <h1 class="font-weight-bold mb-0 mt-3">
                                <b style="font-weight: 400;">
                                     {{devis.Formule[0].nom_formule.toUpperCase() }}
                                </b>
                                </h1>
                                    <h1 class="font-weight-bold mb-0 mt-3">
                                    <b>
                                        {{ devis.Formule[0].amount_total_emis.toLocaleString() }} FCFA
                                    </b>
                                    </h1>
                                    <a href="javascript: void(0);" class="btn btn-outline-primary pr-btn mt-4" @click="btn2_clicked(devis)">{{ $t('list_devis.souscrire_label') }}</a>
                                    <div class="mt-3">
                                        <ul>
                                            <li class="mt-2"><a class="button-function" href="javascript: void(0);" @click="showDetailAuto()">Afficher détails</a></li>
                                        </ul>
                                    </div>
                                   
                                </div>
                                <div data-v-221edead="" id="collapse-result-3" style="" class="collapse show" v-show="ifDevisIsAuto">
                                                <div data-v-221edead="" class="card-default-other text-left">
                                                    <div data-v-221edead="" class="table-responsive">
                                                        <pre>{{ car.lib_usage }}</pre>
                                                        <pre>{{ car.immatriculation }}</pre>
                                                       
                                                    </div>
                                                    <!-- <pre>{{ devisDetails.Formule }}</pre> -->
                                                    <div data-v-221edead="" class="table-responsive" v-for="garantie in devis.Formule" :key="garantie">
                                                        <li style="list-style: none;" v-for="gar in garantie.Garanties" :key="gar">
                                                            <span>{{ gar.Lib_Garantie }}</span>

                                                        </li>
                                                       
                                                    </div>


                                                   
                                                </div>
                                            </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
                <!-- popup pour demande d'assistance -->
                <!-- popup pour demande d'assistance -->
                <v-dialog v-model="assistanceDialog" max-width="800">
                  <v-card elevation="24" class="border-radius">
                    <v-card-text style="background:#FAFAFA">
                      <div class="wizard-tab-content">
                          <div role="tabpanel" id="infosAssistance" aria-hidden="true" aria-labelledby="step-infosAssistance" class="wizard-tab-container">
                              <div>
                                  <div class="loan-group loan-group-0">
                                      <div class="fields">
                                          <div class="field-title font-weight-bold">{{ $t('list_devis.assistance_form.assistance_title') }}</div>
                                          <div class="row">
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="HoraireRappel" class="field-label">{{ $t('list_devis.assistance_form.horaire_rappel_label') }}</label>
                                                      <select id="HoraireRappel" name="infosAssis" class="field-select" v-model="horaire">
                                                          <option v-for="itm in itema" :key="itm" :value="itm">{{itm}}</option>
                                                      </select>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="CanalRappel" class="field-label">{{ $t('list_devis.assistance_form.canal_rappel_label') }}</label>
                                                      <select id="CanalRappel" name="infosAssis" class="field-select" v-model="canal">
                                                          <option v-for="itm in rappel" :key="itm" :value="itm">{{itm}}</option>
                                                      </select>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default mb-4 mb-sm-0">
                                                      <label for="nom" class="field-label">{{ $t('list_devis.assistance_form.nom_label') }}</label>
                                                      <input v-model="name" :placeholder="$t('list_devis.assistance_form.nom_placeholder')" id="nom" name="infosAssis" class="field-input">
                                                  </div>
                                              </div>
                                          </div>

                                          <div class="row">
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default">
                                                      <label for="num" class="field-label">
                                                        {{ $t('list_devis.assistance_form.telephone_label') }}
                                                      </label>
                                                      <div class="input-group value-loan">
                                                          <input :placeholder="$t('list_devis.assistance_form.telephone_placeholder')" v-model="tel" id="num" name="infosAssis" class="field-input">
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default">
                                                      <label for="Object" class="field-label">
                                                        {{ $t('list_devis.assistance_form.objet_label') }}
                                                      </label>
                                                      <div class="input-group value-loan">
                                                          <input :placeholder="$t('list_devis.assistance_form.objet_placeholder')" v-model="objetRappel" id="Object" name="infosAssis" disabled class="field-input">
                                                      </div>
                                                  </div>
                                              </div>
                                              <div class="col-sm-4">
                                                  <div class="field-group field-default">
                                                      <label for="Remarque" class="field-label">
                                                        {{ $t('list_devis.assistance_form.remarque_label') }}
                                                      </label>
                                                      <div class="input-group value-loan">
                                                          <textarea rows="4" cols="50" :placeholder="$t('list_devis.assistance_form.remarque_placeholder')" v-model="remarques" id="Remarque" name="infosAssis" class="field-input"></textarea>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="wizard-card-footer clearfix">
                          <div class="wizard-footer-left">
                              <button @click="assistanceDialog = false" type="button" class="wizard-btn">
                                  <span class="fas fa-arrow-left"></span>
                                  {{ $t('list_devis.assistance_form.bouton_fermer_label') }}
                              </button>
                          </div>
                          <div class="wizard-footer-right">
                              <button @click="AddAssistance()" type="button" class="wizard-btn">
                                {{ $t('list_devis.assistance_form.bouton_valider_label') }}
                              </button>
                          </div>
                      </div>
                  </v-card-text>
                  </v-card>
                </v-dialog>

                 <!-- popup pour afficher les infos du véhicule -->
                <!-- popup pour afficher les infos du véhicule -->
                <v-dialog v-model="infoVehiculeModal" max-width="500">
                  <v-card elevation="24" class="border-radius">
                    <v-card-text style="background:#FAFAFA">
                      <div class="wizard-tab-content">
                          <div role="tabpanel" id="infosAssistance" aria-hidden="true" aria-labelledby="step-infosAssistance" class="wizard-tab-container">
                              <div>
                                  <div class="loan-group loan-group-0">
                                      <div class="fields">
                                          <div class="field-title font-weight-bold">{{ $t('list_devis.info_vehicule_title') }}</div>
                                          <div class="ml-4 row">
                                             <p v-html="sanitizeHtml(infoVehicule)"></p>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="wizard-card-footer clearfix">
                          <div class="wizard-footer-left">
                              <button @click="infoVehiculeModal = false" type="button" class="wizard-btn">
                                  <span class="fas fa-arrow-left"></span>
                                  {{ $t('list_devis.assistance_form.bouton_fermer_label') }}
                              </button>
                          </div>
                      </div>
                  </v-card-text>
                  </v-card>
                </v-dialog>

                  <div v-if="dialogLoadingToPayment && isDesktop" class="loading-state">
        <div class="loading"></div>
    </div>
            </div>

        </v-container>


        <!-- Modal loader start-->
         <div v-if="dialogLoading" class="loading-state">
            <div class="loading"></div>
            <span class="ml-3 loading-text">{{ $t('paiement.sante.popup_file_generator.title') }}</span>
        </div>

        <!-- <div class="text-xs-center">
            <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
                <v-card color="orange" dark>
                    <v-card-text>
                        {{ $t('paiement.sante.popup_file_generator.title') }}
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div> -->
    </v-container>
</template>

<script>
    import Api from '../services/Api'
    import store from "../store/store";
    import {mapGetters} from 'vuex'
    import PushInDataLayer from '../services/TagManager'

    export default {
        name: "ListDevis",
        data() {
            return {
                infoVehiculeModal : false,
                car:null,
                sunu_formulars:null,
                assuraf_data : null,
                dernierDevis:null,
                ifDevisIsAuto: false,
                ecommerce:[],
                devis_price:null,
                HideDive: null,
                HideButton: true,
                devisVoyage: [],
                listdevis: [],
                DevisFinal: [],
                assureurs: [],
                assistanceDialog: false,
                notif: null,
                GtmAssistanceVal:{},
                dialogLoading: false,
                dialogLoadingToPayment : false,
                brancheTocheck: '',
                Mano: null,
                ToastTabSucess: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'success',
                    className: 'custom-success-class'
                }, // Customized options for success toast
                ToastTabError: {
                    theme: "toasted-primary",
                    position: "top-center",
                    duration: 5000,
                    fitToScreen: true,
                    type: 'error'
                },// Customized options for error toast
                headers: [
                    {text: 'Assureurs', align: 'left', sortable: false, value: 'societe'},
                ],
                itema: ['Le plus tôt possible', 'Dans la matinée', 'Dans la journée'],
                rappel: ['Whatsapp', 'Appel', 'Email'],
                objet: ['Devis', 'Souscription', 'Contrat', 'Paiement', 'Conseil', 'Sinistre', 'Autres'],
                horaire: null,
                canal: null,
                name: null,
                tel: null,
                objetRappel: null,
                remarques: null,
                timer: '',
                ExitByUser: true
            }
        },
        computed: {
            ...mapGetters([
                'username'
            ])
        },
        created() {
            this.fetchEventsList();
            this.timer = setInterval(this.fetchEventsList, 60000)
        },

    methods: {
        sanitizeHtml(html) {
            if (!html) return '';
            const root = document.createElement('div');
            root.innerHTML = html;
            const allowed = new Set(['B','I','EM','STRONG','UL','OL','LI','BR','P','SPAN']);
            const walk = (node) => {
                const children = Array.from(node.childNodes);
                for (const child of children) {
                    if (child.nodeType === 1) {
                        const tag = child.tagName.toUpperCase();
                        if (!allowed.has(tag)) {
                            const text = document.createTextNode(child.textContent || '');
                            node.replaceChild(text, child);
                            continue;
                        }
                        Array.from(child.attributes).forEach(attr => {
                            const name = attr.name.toLowerCase();
                            const value = attr.value || '';
                            if (name.startsWith('on') || /javascript:/i.test(value)) {
                                child.removeAttribute(attr.name);
                            }
                        });
                        walk(child);
                    } else if (child.nodeType === 8) {
                        node.removeChild(child);
                    }
                }
            };
            walk(root);
            return root.innerHTML;
        },
            splitArray(array) {
                if (!Array.isArray(array) || array.length === 0) {
                    return {
                        firstItem: {},
                        others: []
                    };
                }
                const [firstItem, ...others] = array;
                return {
                    firstItem, // ✅ objet
                    others     // ✅ tableau des objets restants
                }
            },

            // showDetailAuto(devis){
            //     for(let garantie of devis.Formule) {
            //         console.log(':::::::::: garantie :::::::::::', garantie)
            //         for(let gar of garantie) {
            //             console.log(':::::::: garantie SUNU', gar)
            //         }
            //     }


            //     // if(this.ifDevisIsAuto == false){
            //     //     this.infoVehicule = devis.matchingArray
            //     //     //this.ifDevisIsAuto = true
            //     //     this.infoVehiculeModal = true

            //     // }else{
            //     //     this.ifDevisIsAuto = false
            //     // }

            // },

            showDetailAuto(){

                if(this.ifDevisIsAuto == false){
                    this.ifDevisIsAuto = true
                }else{
                    this.ifDevisIsAuto = false
                }

            },

            fetchEventsList() {
                this.Mano = this.Mano - 1;
                if (this.Mano == 0) {
                    this.ExitByUser = false;
                    this.$store.dispatch('setDevis', null);
                    this.$router.push('/')
                }
            },

            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },

            isTablette() {
                if (screen.width > 425 && screen.width <= 768) {
                    return true
                } else {
                    return false
                }
            },

            isDesktop: function () {
                if (screen.width > 768) {
                    return true;
                } else {
                    return false;
                }
            },

            assistanceDialogManip(devis)
            {
                this.devis_price = devis.tarif

                this.GtmAssistanceVal.branche = devis.branche.toLowerCase()
                this.GtmAssistanceVal.insurer_name = devis.nom
                this.GtmAssistanceVal.step = 1
                this.GtmAssistanceVal.event = 'receive_call_step1'

                PushInDataLayer(this.GtmAssistanceVal)

                this.objetRappel = 'Devis : ' + devis.numero;
                this.name = store.state.user.prenom.toUpperCase() + '-' + store.state.user.nom.toUpperCase();
                this.tel = store.state.user.telephone_port;
                this.assistanceDialog = true
            },

            AddAssistance()
            {
                if (this.horaire && this.canal && this.name && this.tel && this.objetRappel && this.remarques) {
                    const assist = {
                        horaire: this.horaire,
                        canal: this.canal,
                        name: this.name,
                        tel: this.tel,
                        objetRappel: this.objetRappel,
                        remarques: this.remarques,
                        userid: store.state.user._id
                    };

                    let Gtm2 = {
                        branche : this.GtmAssistanceVal.branche,
                        schedule : this.horaire,
                        insurer_name : this.GtmAssistanceVal.insurer_name,
                        step : 2,
                        price : this.devis_price,
                        channel :this.canal,
                        event : 'receive_call_step2'
                    }

                    Api().post('assistances/create', assist)
                        .then(resp => {
                            PushInDataLayer(Gtm2)
                            if (resp.data.info == 'ok')
                            {
                                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                                this.assistanceDialog = false;
                                this.horaire = '';
                                this.canal = '';
                                this.name = '';
                                this.tel = '';
                                this.objetRappel = '';
                                this.remarques = ''
                            } else if (resp.data.info == 'nok')
                            {
                                this.$toasted.show(resp.data.msg, this.ToastTabError)
                            }
                        })

                } else {
                    this.$toasted.show("Tous les champs sont obligatoires !", this.ToastTabError)
                }

            },

            getPartner: function (assur) {
                let partenaire = this._.find(this.$store.state.devis.result.partenaire, function (o) {
                    return o._id === assur
                });
                return partenaire
            },

            btn1_clicked: function (item)
            {
                let Gtmval = {
                    branche:item.branche.toLowerCase(),
                    insurer_name:item.nom,
                    price:item.tarif,
                    event:'view_price'
                }

                PushInDataLayer(Gtmval)

                this.HideDive = item.id;
                this.HideButton = item.id + 'hidden'
            },

            btn2_clicked: function (devis) {
                let devis_data = {
                    formule: devis.Formule[0],
                    car: this.car,
                    assuraf_data : this.assuraf_data,
                }
                console.log(':::::::::: devis_data ::::::::::::::::', devis_data)
                this.dialogLoadingToPayment = true
                Api().post('attestation_digitale/devis/assuraf/', devis_data)
                    .then(response => {
                        this.dialogLoadingToPayment = false
                        this.$store.dispatch('setDevisPayement', response.data);
                        this.$router.push('/sunu/payement')
                    }).catch(err => {

                    })
            },

            btn3_clicked: function () {
                this.HideDive2 = true;
                this.HideButton2 = false;
            },

            getImgUrl(pic) {
                if (pic) {
                    return pic
                } else {
                    return require('../assets/img/assuraf_sm.png')
                }
            },

            SendDevisByMail: function (devis)
            {
                let Gtmval = {
                    branche:devis.branche.toLowerCase(),
                    insurer_name:devis.nom,
                    price:devis.tarif,
                    event:'quote_by_mail'
                }

               PushInDataLayer(Gtmval)

                Api().get('devis/mydevisbyemail/' + devis.id)
                .then(response => {
                    this.notif = response.data.info
                })
            },

            Download_devis: function (devis){
                //console.log(":::::::: devi ::::::::::::", devis)

                let Gtmval = {
                    branche:devis.branche.toLowerCase(),
                    insurer_name:devis.nom,
                    price:devis.tarif,
                    event:'download_quote'
                }

               PushInDataLayer(Gtmval)
               this.dialogLoading = true;
                Api().get('devis/download/' + devis.id)
                    .then(response => {
                        let url = response.data.lien;
                        //console.log(":::::::: url devis ::::::::::::", url)
                        let WinOpener = null
                        this.dialogLoading = false, WinOpener = window.open(),WinOpener.location = url
                        })
            },

            DataLayerPusherCheckValue(tab,val){
                let checker = 0
                for(let t of tab)
                {
                    if(t.item_id==val)
                    {
                        checker = 1
                    }
                }
                return checker
            },

        },
        beforeDestroy() {
            clearInterval(this.timer);
            if (this.ExitByUser == true) {
                this.$store.dispatch('setDevis', null)
            }

        },
        watch: {
            notif: function () {
                if (this.notif == 'ok') {
                    this.$toasted.show('Votre devis vous a été envoyé par mail !', this.ToastTabSucess);
                    this.notif = null
                } else if (this.notif == 'nok') {
                    this.$toasted.show("L'envoi du devis par mail a échoué !", this.ToastTabError);
                    this.notif = null
                }
            }
        },
        mounted() {
            window.scrollTo(0, 0);
            this.dernierDevis   = this.splitArray(this.$store.state.devis.cotations);
            this.assuraf_data   = this.$store.state.devis.assuraf_data
            this.brancheTocheck = this.assuraf_data.branche
            this.car            = this.dernierDevis.firstItem//SunuData[0].car,
            this.sunu_formulars = this.dernierDevis.others
            this.listdevis      = this.$store.state.devis
        }
    }
</script>

<style scoped>
    @import "../assets/css/liste_devis.css";
    @import "../assets/css/liste_devis_button.css";
    @import "../assets/css/devis_css.css";
    /* .container {
          padding: 0px !important;
      } */
    .row-container {
        background: white;
    }

    .List-garanties-option li {
        list-style: none;
        border-bottom: 1px solid lightgrey;
    }

    .List-cout li {
        list-style: none;
    }

    .list-boutons li {
        list-style: none;
    }

    .logo-assureur {
        border: 1px solid lightgrey;
    }

    .right--texting {
        text-align: right;
    }

    .right--texting ul li .col-lg-6:hover {
        background: #ffa409;
        color: white;
        text-decoration: none;
    }

    .greyLabel {
        color: grey
    }

    .selectatDesktop {
        background: url(https://) no-repeat right;
        -webkit-appearance: none;
        background-position-x: 90%;
        border-bottom: 1px solid gray;
    }

    .georgia {
        font-family: Georgia !important;
    }

    .border-radius {
        border-radius: 20px !important
    }

    .focusablee :hover {
        background: #DCDCDC;
    }

    .policeLato{
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }
    .pricing-box {
    background: white;
    box-shadow: 0 3px 12px rgba(6, 11, 47, 0.06);
    margin-bottom: 30px;
    position: relative;
    overflow: hidden;
    .pricing-icon-bg {
        background: rgba(#ffa409, 0.12);
        color: ffa409;
        display: block;
        height: 80px;
        width: 80px;
        line-height: 100px;
        margin: 0 auto;
        border-radius: 25% 25% 4% 25% / 25% 25% 4% 25%;
        box-shadow: 0 0 0 7px rgba(#ffa409, 0.03);
        transition: all 0.5s;
    }
    .pricing-item {
        li {
            padding: 10px 0;
        }
    }
    .pr-btn {
        position: relative;
        z-index: 1;
        color: #ffa409;
        border: 1px solid #ffa409;
        
    }
    .pr-btn:hover {
        background-color: #ffa409;
        color: #fff;
    }
    &:hover, &.active {
        .pricing-icon-bg {
            background-color: #ffa409;
            box-shadow: 0 0 0 7px rgba(ffa409, 0.06);
            color: white;
            border-radius: 4% 20% 20% 20% / 4% 20% 20% 20%;
        }
    }
}

.button-function {
    list-style: none;
    color: rgb(24, 45, 51);
    text-decoration: none;
    border-bottom: 1px solid;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 19px;
}
.button-function:hover {
    background-color: #ffa409;
    color: #fff;
    border: 1px solid #ffa409;
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
</style>
